import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import NotificationSystem from "react-notification-system";

import { setNotificationSystem } from "../store/slices/toast";
import StorageHelper from "../utilities/StorageHelper";
import AppConfig from "../config/AppConfig";
import history from "../router/history";
import { fetchCompanyConfig } from "store/slices/company";
// import { getCompanyConfig } from "store/slices/company";

const AppContainer = (props) => {
  const dispatch = useDispatch();
  
  // const companyConfig = useSelector(getCompanyConfig) || {};

  const hostname = window.location.hostname;
  const listDomainSuperAdmin = process.env.REACT_APP_DOMAIN_SUPER_ADMIN.split(',');

  const onFocus = async () => {
    const token = StorageHelper.getCookie(AppConfig.STORAGE_KEYS.token);
    const isAuthPage = history.location.pathname.includes("auth");
    const isPrivatePage = history.location.pathname.includes("admin");
    let path;
    if (isPrivatePage || isAuthPage) {
      if (!token && !isAuthPage) {
        path = "/auth/login";
      } else if (token && isAuthPage) {
        const user = StorageHelper.getLocalObject(AppConfig.STORAGE_KEYS.user);        
        if (user.roleId === AppConfig.USER_ROLES.ADMIN) {
          path = "/admin/dashboard";
        } else {
          path = "/dashboard";
        }          
      }
    }
    history.push(path);
  };

  useEffect(() => {
    // window.addEventListener("focus", onFocus);

    // return () => {
    //   window.removeEventListener("focus", onFocus);
    // };
    dispatch(fetchCompanyConfig({ domain: hostname }));
  }, []);

  return (
    <>
      <NotificationSystem
        ref={(ref) => {
          dispatch(setNotificationSystem(ref));
        }}
        newOnTop
        allowHTML
        style={{
          Containers: {
            DefaultStyle: {
              right: 20,
            },
          },
          NotificationItem: {
            DefaultStyle: {
              background: "none",
              padding: 0,
              marginTop: 20,
              boxSizing: "none",
              border: "none",
            },
          },
        }}
      />
      {props.children}
    </>
  );
};

AppContainer.propTypes = {
  children: PropTypes.any,
};

export default AppContainer;
